import { inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

/** Move focus to the activated view's heading so a screen reader lands on the new
 *  content (WCAG 2.2 focus management). Call once, from an injection context. */
export function focusHeadingOnNavigation(): void {
  const router = inject(Router);
  router.events
    .pipe(
      // id 1 is the page-load navigation: leave focus at the document start there.
      filter((event) => event instanceof NavigationEnd && event.id > 1),
      takeUntilDestroyed(),
    )
    .subscribe(() => {
      // NavigationEnd fires before the activated view is rendered — focus on the next task.
      setTimeout(() =>
        document.querySelector<HTMLElement>('h1[tabindex="-1"]')?.focus(),
      );
    });
}
